import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=ad1477c8&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=js"
export * from "./MyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1477c8",
  null
  
)

export default component.exports